/**
 * Browser Entry Point
 * For <script> tag usage (UMD format)
 * Note: WASM module is ESM format, loaded via dynamic import()
 */

import { BeautyEffectEngine } from '../core/engine.js';
import { EngineConfig } from '../core/config.js';
import { FacebetterError } from '../core/errors.js';
import * as constants from '../core/constants.js';
import * as wasmLoader from './wasm-loader.js';
import * as imageUtils from './image-utils.js';

// Browser-specific GPU canvas management
function ensureGPUPixelCanvas() {
  if (typeof document === 'undefined') {
    return;
  }
  
  let canvas = document.getElementById('gpupixel_canvas');
  if (!canvas) {
    canvas = document.createElement('canvas');
    canvas.id = 'gpupixel_canvas';
    canvas.style.display = 'none';
    canvas.width = 1;
    canvas.height = 1;
    if (document.body) {
      document.body.appendChild(canvas);
    }
  }
}

function cleanupGPUPixelCanvas() {
  // Cleanup is handled by engine instance
}

// Create platform API
const platformAPI = {
  loadWasmModule: () => wasmLoader.loadWasmModule(),
  getWasmModule: wasmLoader.getWasmModule,
  getWasmBuffer: wasmLoader.getWasmBuffer,
  toImageData: imageUtils.toImageData,
  verifyAppKeyOnline: imageUtils.verifyAppKeyOnline,
  ensureGPUPixelCanvas,
  cleanupGPUPixelCanvas
};

// Export factory function for UMD
export function createBeautyEffectEngine(config) {
  return new BeautyEffectEngine(config, platformAPI);
}

// Create a wrapped BeautyEffectEngine class that automatically injects platformAPI
// This allows users to use: new BeautyEffectEngine(config) without passing platformAPI
class BrowserBeautyEffectEngine extends BeautyEffectEngine {
  constructor(config) {
    // Automatically inject platformAPI for browser environment
    super(config, platformAPI);
  }
}

// Export all constants and classes
export {
  BrowserBeautyEffectEngine as BeautyEffectEngine,
  EngineConfig,
  FacebetterError
};

// Export constants with proper names
export const BeautyType = constants.BeautyType;
export const BasicParam = constants.BasicParam;
export const ReshapeParam = constants.ReshapeParam;
export const MakeupParam = constants.MakeupParam;
export const BackgroundMode = constants.BackgroundMode;
export const ProcessMode = constants.ProcessMode;
export const VirtualBackgroundOptions = constants.VirtualBackgroundOptions;

// Export WASM loader
export { loadWasmModule } from './wasm-loader.js';

// Default export
export default {
  BeautyEffectEngine: BrowserBeautyEffectEngine,
  EngineConfig,
  FacebetterError,
  ...constants,
  loadWasmModule: wasmLoader.loadWasmModule
};

